<nav class="container-fluid section-nav-shell d-flex align-items-center" aria-label="Sub-section navigation">
    <div class="container-xxxl d-flex flex-column d-xl-block" *ngIf="links.length > 0">
        <button class="section-nav-toggle d-xl-none bg-transparent border-0 w-100 text-start d-flex align-items-center justify-content-between p-0" (click)="toggleNav()">
            <span>Navigate to sub-section</span>
            <i [ngClass]="[isNavOpen ? 'icon-gard-drop-arrow-up' : 'icon-gard-drop-arrow-down']"></i>
        </button>
        <ul class="section-nav" [class.open]="isNavOpen">
            <ng-container *ngFor="let section of links">
                <li class="nav-item" *ngIf="!section.hidden">
                    <a class="section-link fs-16 fs-lg-18" href="#{{ section.id }}" (click)="jumpToSection($event, section.id)">
                        {{ section.description }}
                    </a>
                </li>
            </ng-container>
        </ul>
    </div>
</nav>
